const normalizeExternalPath = (value) => {
  const rawValue = (value || "").trim();

  if (!rawValue) {
    return "/sales";
  }

  if (/^https?:\/\//i.test(rawValue)) {
    return rawValue.replace(/\/+$/, "");
  }

  const withLeadingSlash = rawValue.startsWith("/") ? rawValue : `/${rawValue}`;
  return withLeadingSlash.replace(/\/+$/, "") || "/sales";
};

export const SALES_PORTAL_URL = normalizeExternalPath(process.env.REACT_APP_SALES_PORTAL_URL);
